import React, { useState, useEffect } from 'react';
import moment from 'moment'
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import { BsPlusSquareDotted, BsLink45Deg ,BsPencilSquare, BsTrash} from "react-icons/bs";
import { storage, createResource, updateResourcesData } from '../../firebase.js';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./ResourceModal.css"

const CreateActivity = (props) => { 
    const resource = props.resource;
    const [actTitle, setTitle] = useState("");
    const [actDes, setDes] = useState("");
    const [actUrl, setImageUrl] = useState(null);
    const handleClose = props.close;
    // const [date, setDate] = useState(new Date().toLocaleDateString("en-GB"));
    const [date, setDate] = useState("");
    const [category, setCategory] = useState("");
    const [courseCategory, setCourseCategory] = useState("");
    const [linkData, setLinkData] = useState({});
    const [resTitle, setresTitle] = useState(null);
    const [reslink, setLink] = useState(null);
    const [linkArr, setLinksArr] = useState([]); 
    const [show, setShow] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [updateLinkArr, setUpdateLinksArr] = useState(resource.links !== undefined ? resource.links : []); 
    const handleShow = () => setShow(true);
    const handleLinkClose = () => setShow(false);
    const handleAddModalShow = () => setShowAddModal(true);
    const handleAddModalClose = () => setShowAddModal(false);
    const [page, setPage] = useState("");

    // Populate form fields when in duplicate mode or edit mode
    useEffect(() => {
        if (props.status === "duplicate" && resource.title) {
            setTitle(`${resource.title} (Copy)`);
            setDes(resource.description || "");
            setImageUrl(resource.image || null);
            setDate(resource.date || "");
            setCategory(resource.category || "");
            setCourseCategory(resource.courseCategory || "");
            setPage(resource.page || "");
            setUpdateLinksArr(resource.links || []);
        } else if (props.status === "edit" && resource.title) {
            setUpdateLinksArr(resource.links || []);
        }
    }, [props.status, resource]);

    // Debug: Log values for troubleshooting
    useEffect(() => {
        console.log("Modal Status:", props.status);
        console.log("Page State:", page);
        console.log("Resource Page:", resource.page);
        console.log("Resource Object:", resource);
        console.log("Should Show Course Category:", 
            ((props.status === "edit" || props.status === "duplicate") && 
             ((page !== "" && page === "university") || (page === "" && resource.page === "university")))
        );
    }, [props.status, page, resource.page]);

    const addLinks = () => {  
        setShowAddModal(false)
        if (props.status === "edit") {
            setUpdateLinksArr(oldArray => [...oldArray, { title: resTitle, link: reslink }]);
        } else {
            setLinksArr(oldArray => [{ title: resTitle, link: reslink }, ...oldArray]);
        }
        setresTitle(null);
        setLink(null);
    }

    const updateLinks = (arrIndex) => { 
        resource.links[arrIndex] = { 
            title: resTitle !== null ? resTitle : linkData.title, 
            link: reslink !== null ? reslink : linkData.link 
        };
        console.log(resource.links)
        setUpdateLinksArr(resource.links);
        setShow(false)
    }

    const deleteLink = (index) => {
        const updatedLinks = linkArr.filter((_, i) => i !== index);
        setLinksArr(updatedLinks);
    }

    const deleteUpdateLink = (index) => {
        if (window.confirm("Are you sure you want to delete this resource link?")) {
            const updatedLinks = updateLinkArr.filter((_, i) => i !== index);
            setUpdateLinksArr(updatedLinks);
        }
    }

    const setCoverUpload = (imageUpload) => {
        console.log(imageUpload)
        if (imageUpload === null) return;
        const imageRef = ref(storage, `resources/${imageUpload.name}`);
        uploadBytes(imageRef, imageUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setImageUrl(url)
            });
        });
    }

    const createResources = () => {
        if(category === ""){
            setCategory("education")
        }
        if(page === ""){
            setPage("university")
        }
        createResource(actTitle, actDes, actUrl, date, page, category, courseCategory, linkArr).then((res) => {
            console.log(res)
            handleClose();
            window.location.reload();
        });
    }

    const updateResources = () => { 
        let upRitle = actTitle === "" ? resource.title : actTitle;
        let upDes= actDes === "" ? resource.description : actDes; 
        let upCategory = category === "" ? resource.category : category;
        let upCourseCategory = courseCategory === "" ? resource.courseCategory : courseCategory;
        let upPage = page === "" ? resource.page !== undefined ? resource.page : "" : page;
        let upDate = date === "" ? resource.date : date;
        let upImage = actUrl || resource.image;
        updateResourcesData(resource.id , upRitle, upDes, upCategory, upCourseCategory, upPage, upDate, updateLinkArr.length === 0 ? linkArr : updateLinkArr, upImage);
        handleClose();
    }

    const duplicateResource = () => {
        // Use the state values, or fall back to resource values if state is empty
        let duplicateTitle = actTitle || `${resource.title} (Copy)`;
        let duplicateDes = actDes || resource.description;
        let duplicateCategory = category || resource.category || "education";
        let duplicateCourseCategory = courseCategory || resource.courseCategory || "";
        let duplicatePage = page || resource.page || "university";
        let duplicateDate = date || resource.date || new Date().toLocaleDateString("en-GB");
        let duplicateImage = actUrl || resource.image;
        let duplicateLinks = updateLinkArr.length > 0 ? updateLinkArr : (linkArr.length > 0 ? linkArr : (resource.links || []));
        
        if (!duplicateTitle || !duplicateDes || !duplicateImage) {
            alert("Please fill in all required fields (Title, Description, and Image)");
            return;
        }
        
        createResource(duplicateTitle, duplicateDes, duplicateImage, duplicateDate, duplicatePage, duplicateCategory, duplicateCourseCategory, duplicateLinks)
            .then((res) => {
                console.log("Duplicated resource:", res)
                handleClose();
                window.location.reload();
            })
            .catch((error) => {
                console.error("Error duplicating resource:", error);
                alert("An error occurred while duplicating the resource. Please try again.");
            });
    }


    return (
        <>
            <Modal show={props.show} centered  size="lg">
            <Modal.Header closeButton onClick={props.close}>
            <Modal.Title>{props.status === "edit" ? "Edit Resource" : props.status === "duplicate" ? "Duplicate Resource" : "Add New Resource"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-3'>Resource Title: <strong>*</strong></Form.Label>
                        {props.status === "edit" ? (
                            <Form.Control className='col-md-8' type="text" placeholder="Enter Resource Title" defaultValue={resource.title} onChange={e => setTitle(e.target.value)}/>
                        ) : props.status === "duplicate" ? (
                            <Form.Control className='col-md-8' type="text" placeholder="Enter Resource Title" value={actTitle} onChange={e => setTitle(e.target.value)}/>
                        ) : (
                            <Form.Control className='col-md-8' type="text" placeholder="Enter Resource Title" onChange={e => setTitle(e.target.value)}/>
                        )}
                    </Form.Group>
                    <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-3'>Resource Description :  <strong>*</strong></Form.Label>
                        {props.status === "edit" ? (
                            <Form.Control className='col-md-8' as="textarea" rows={3} placeholder="Enter Resource Description" defaultValue={resource.description} onChange={e => setDes(e.target.value)}/>
                        ) : props.status === "duplicate" ? (
                            <Form.Control className='col-md-8' as="textarea" rows={3} placeholder="Enter Resource Description" value={actDes} onChange={e => setDes(e.target.value)}/>
                        ) : (
                            <Form.Control className='col-md-8' as="textarea" rows={3} placeholder="Enter Resource Description" onChange={e => setDes(e.target.value)}/>
                        )}
                    </Form.Group>
                    <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-3'>Upload Photo:<strong>*</strong></Form.Label>

                        {props.status === "edit" || props.status === "duplicate" ? (
                            <Col md={8} className="p-0">
                                <img src={actUrl || resource.image} className="border w-75 mb-2" alt={resource.title} />
                                <Form.Group controlId="formFileSm" className="col-md-9 fileInput">
                                    <Form.Control type="file" onChange={(e) => {setCoverUpload(e.target.files[0]);}}/>
                                </Form.Group>
                            </Col>
                        ) : (
                            <Form.Group controlId="formFileSm" className="col-md-9 fileInput">
                                <Form.Control type="file" onChange={(e) => {setCoverUpload(e.target.files[0]);}}/>
                            </Form.Group>
                        )}
                    </Form.Group>
                    <Form.Group className="mb-4 row">
                        <Form.Label className='col-md-3'> Date :  <strong>*</strong></Form.Label>
                        {props.status === "edit" ? (
                            <Col md={8} className="p-0">
                                <Form.Control  defaultValue={moment(resource.date, "DD-MM-YYYY").locale('en').format('YYYY-MM-DD')} type="date" onChange={e => setDate(new Date(e.target.value).toLocaleDateString("en-GB"))} />
                            </Col>
                        ) : props.status === "duplicate" ? (
                            <Col md={8} className="p-0">
                                <Form.Control value={date ? moment(date, "DD/MM/YYYY").format('YYYY-MM-DD') : ""} type="date" onChange={e => setDate(new Date(e.target.value).toLocaleDateString("en-GB"))} />
                            </Col>
                        ) : (
                            <Col md={8} className="p-0">
                                <Form.Control className='col-md-9' type="date" onChange={e => setDate(new Date(e.target.value).toLocaleDateString("en-GB"))}/>
                            </Col>
                        )}
                    </Form.Group>
                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-3'> Category :  <strong>*</strong></Form.Label> 
                                {props.status === "edit" ? (
                                    <Col md={8} className="p-0">  
                                       <Form.Select defaultValue={resource.category} onChange={e => setCategory(e.target.value)} placeholder='Add Category for your Resource'>
                                            {/* <option>Add Category for your Resource</option> */}
                                            <option value="education">Education</option>
                                            <option value="wasteeducation">Waste Education</option>
                                            <option value="activity">Waste Reduction Activity</option>
                                            <option value="community">Zero Waste</option>
                                            <option value="research">Research</option>
                                            <option value="naturebased">Nature Based Solutions</option>
                                            <option value="other">Other</option>
                                        </Form.Select>
                                    </Col>
                                ) : props.status === "duplicate" ? (
                                    <Col md={8} className="p-0">  
                                       <Form.Select value={category} onChange={e => setCategory(e.target.value)} placeholder='Add Category for your Resource'>
                                            {/* <option>Add Category for your Resource</option> */}
                                            <option value="education">Education</option>
                                            <option value="wasteeducation">Waste Education</option>
                                            <option value="activity">Waste Reduction Activity</option>
                                            <option value="community">Zero Waste</option>
                                            <option value="research">Research</option>
                                            <option value="naturebased">Nature Based Solutions</option>
                                            <option value="other">Other</option>
                                        </Form.Select>
                                    </Col>
                                ) : (
                                    <Col md={7} className='p-0'> 
                                        <Form.Select aria-label="Default select example" onChange={e => setCategory(e.target.value)}>
                                            {/* <option>Add Category for your Resource</option> */}
                                            <option value="education">Education</option>
                                            <option value="wasteeducation">Waste Education</option>
                                            <option value="activity">Waste Reduction Activity</option>
                                            <option value="community">Zero Waste</option>
                                            <option value="research">Research</option>
                                            <option value="naturebased">Nature Based Solutions</option>
                                            <option value="other">Other</option>
                                        </Form.Select>
                                    </Col>
                                )} 
                        </Form.Group>

                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-3'>{props.status === "edit" || props.status === "duplicate" ? "Update Page :" : "Add  Page :"} <strong>*</strong></Form.Label>
                            <Col md={8} className='p-0'>
                                {props.status === "edit" ? ( 
                                    <Form.Select defaultValue={resource.page !== undefined ? resource.page : ""}  onChange={e => setPage(e.target.value)}>
                                        {/* <option>Select Your Page</option> */}
                                        <option value="university">University</option>
                                        <option value="school">School</option>
                                    </Form.Select>
                                ) : props.status === "duplicate" ? ( 
                                    <Form.Select value={page}  onChange={e => setPage(e.target.value)}>
                                        {/* <option>Select Your Page</option> */}
                                        <option value="university">University</option>
                                        <option value="school">School</option>
                                    </Form.Select>
                                ) : ( 
                                    <Form.Select aria-label="Default select example"  onChange={e => setPage(e.target.value)}>
                                        {/* <option>Select Your Page</option> */}
                                        <option value="university">University</option>
                                        <option value="school">School</option>
                                    </Form.Select>
                                )}
                            </Col> 
                        </Form.Group>

                        {/* Course Category - Show for both university and school pages */}
                        {(((props.status === "edit" || props.status === "duplicate")) ||
                          (props.status !== "edit" && props.status !== "duplicate" && (page === "university" || page === "school"))) && (
                            <Form.Group className="mb-4 row">
                                <Form.Label className='col-md-3'> Course Category : </Form.Label> 
                                    {props.status === "edit" ? (
                                        <Col md={8} className="p-0">  
                                           <Form.Select defaultValue={resource.courseCategory || ""} onChange={e => setCourseCategory(e.target.value)} placeholder='Add Course Category for your Resource'>
                                                <option value="">Select Course Category</option>
                                                <option value="waste">Waste/Plastic</option>
                                                <option value="development">Energy & Climate</option>
                                                <option value="marine">Marine</option>
                                                <option value="geology">Geospatial & Geology</option>
                                            </Form.Select>
                                        </Col>
                                    ) : props.status === "duplicate" ? (
                                        <Col md={8} className="p-0">  
                                           <Form.Select value={courseCategory} onChange={e => setCourseCategory(e.target.value)} placeholder='Add Course Category for your Resource'>
                                                <option value="">Select Course Category</option>
                                                <option value="waste">Waste/Plastic</option>
                                                <option value="development">Energy & Climate</option>
                                                <option value="marine">Marine</option>
                                                <option value="geology">Geospatial & Geology</option>
                                            </Form.Select>
                                        </Col>
                                    ) : (
                                        <Col md={7} className='p-0'> 
                                            <Form.Select aria-label="Default select example" onChange={e => setCourseCategory(e.target.value)}>
                                                <option value="">Select Course Category</option>
                                                <option value="waste">Waste/Plastic</option>
                                                <option value="development">Energy & Climate</option>
                                                <option value="marine">Marine</option>
                                                <option value="geology">Geospatial & Geology</option>
                                            </Form.Select>
                                        </Col>
                                    )} 
                            </Form.Group>
                        )}

                        <Form.Group className="mb-4 row">
                            <Form.Label className='col-md-3'>Resource Links: <strong>*</strong></Form.Label>
                            <Col md={9} className='row mt-0'>
                                {props.status === "edit" || props.status === "duplicate" ? (
                                    <>
                                        {(updateLinkArr && updateLinkArr.length > 0) ? (
                                            <>
                                                {updateLinkArr.map((data, index) =>
                                                    <Row key={index} className='p-0 mb-3'>
                                                        <div className='d-flex justify-content-between align-items-start'>
                                                            <div className='flex-grow-1'>
                                                                <strong>{data.title}</strong>
                                                                <div className='d-flex align-items-center mt-1'>
                                                                    <BsLink45Deg className='me-2 text-success fs-4'/>
                                                                    <p className='mb-0 text-break' style={{fontSize: '0.9rem', wordBreak: 'break-all'}}>{data.link}</p>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex ms-3'>
                                                                {props.status === "edit" && (
                                                                    <BsPencilSquare className='text-warning fs-5 me-2' onClick={() => {handleShow({ data });setLinkData(data)}} style={{cursor: 'pointer'}} />
                                                                )}
                                                                <BsTrash className='text-danger fs-5' onClick={() => deleteUpdateLink(index)} style={{cursor: 'pointer'}} />
                                                            </div>
                                                        </div>             
                                                        <Modal show={show} centered className='bg-dark'>
                                                            <Modal.Header>
                                                                <Modal.Title> {props.status === "duplicate" ? "Add Resource Link" : "Update Resource Link"}</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <Form.Group className="mb-4 row">
                                                                    <Form.Label className='col-md-4'> Resource Title :  <strong>*</strong></Form.Label>
                                                                    <Form.Control className='col-md-8 me-2' type="text" value={resTitle !== null ? resTitle : linkData.title} placeholder="Enter Resource Title Here" onChange={e => setresTitle(e.target.value)} /> 
                                                                </Form.Group>
                                                                <Form.Group className="mb-4 row">
                                                                    <Form.Label className='col-md-4'> Resource Link :  <strong>*</strong></Form.Label>
                                                                    <Form.Control className='col-md-8 me-2' type="text" value={reslink !== null ? reslink : linkData.link} placeholder="Enter Resource Link Here" onChange={e => setLink(e.target.value)} />
                                                                </Form.Group>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={handleLinkClose}>
                                                                    Cancel
                                                                </Button>
                                                                <Button variant="warning" onClick={() => updateLinks(index)}>
                                                                    Update
                                                                </Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    </Row>
                                                )}
                                                {props.status === "edit" && (
                                                    <>
                                                        <Button variant="secondary" className='col-md-3 mt-3' onClick={handleAddModalShow}><BsPlusSquareDotted className='me-2'/> Add Link</Button>
                                                        <Modal show={showAddModal} centered className='bg-dark'>
                                                            <Modal.Header>
                                                                <Modal.Title>Add Resource Link</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <Form.Group className="mb-4 row">
                                                                    <Form.Label className='col-md-4'> Resource Title :  <strong>*</strong></Form.Label>
                                                                    <Form.Control className='col-md-8 me-2' type="text" placeholder="Enter Resource Title Here" onChange={e => setresTitle(e.target.value)} />
                                                                </Form.Group>
                                                                <Form.Group className="mb-4 row">
                                                                    <Form.Label className='col-md-4'> Resource Link :  <strong>*</strong></Form.Label>
                                                                    <Form.Control className='col-md-8 me-2' type="text" placeholder="Enter Resource Link Here" onChange={e => setLink(e.target.value)} />
                                                                </Form.Group>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={handleAddModalClose}>
                                                                    Cancel
                                                                </Button>
                                                                <Button variant="warning" onClick={addLinks}>
                                                                    Add
                                                                </Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                    </>
                                                )}
                                            </>
                                        ): (
                                            <>
                                                {linkArr.length > 0 && (
                                                    <>
                                                        {linkArr.map((data, index) =>
                                                            <Row key={index} className='p-0 mb-3'>
                                                                <div className='d-flex justify-content-between align-items-start'>
                                                                    <div className='flex-grow-1'>
                                                                        <strong>{data.title}</strong>
                                                                        <div className='d-flex align-items-center mt-1'>
                                                                            <BsLink45Deg className='me-2 text-success fs-4'/>
                                                                            <p className='mb-0 text-break' style={{fontSize: '0.9rem', wordBreak: 'break-all'}}>{data.link}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex ms-3'>
                                                                        <BsTrash className='text-danger fs-5' onClick={() => deleteLink(index)} style={{cursor: 'pointer'}} />
                                                                    </div>
                                                                </div>
                                                            </Row>
                                                        )}
                                                    </>
                                                )} 
                                                <Button variant="secondary" className='col-md-3' onClick={handleShow}><BsPlusSquareDotted className='me-2'/> Add Link</Button> 
                                                <Modal show={show} centered className='bg-dark'>
                                                    <Modal.Header>
                                                        <Modal.Title>Add Resource Link</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Form.Group className="mb-4 row">
                                                            <Form.Label className='col-md-4'> Resource Title :  <strong>*</strong></Form.Label>
                                                            <Form.Control className='col-md-8 me-2' type="text" placeholder="Enter Resource Title Here" onChange={e => setresTitle(e.target.value)} />
                                                        </Form.Group>
                                                        <Form.Group className="mb-4 row">
                                                            <Form.Label className='col-md-4'> Resource Link :  <strong>*</strong></Form.Label>
                                                            <Form.Control className='col-md-8 me-2' type="text" placeholder="Enter Resource Link Here" onChange={e => setLink(e.target.value)} />
                                                        </Form.Group>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleLinkClose}>
                                                            Cancel
                                                        </Button>
                                                        <Button variant="warning" onClick={addLinks}>
                                                            Add
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </>
                                        )}  
                                    </>
                                ) : (
                                    <>
                                        {linkArr.length > 0 && (
                                            <>
                                                {linkArr.map((data, index) =>
                                                    <Row key={index} className='p-0 mb-3'>
                                                        <div className='d-flex justify-content-between align-items-start'>
                                                            <div className='flex-grow-1'>
                                                                <strong>{data.title}</strong>
                                                                <div className='d-flex align-items-center mt-1'>
                                                                    <BsLink45Deg className='me-2 text-success fs-4'/>
                                                                    <p className='mb-0 text-break' style={{fontSize: '0.9rem', wordBreak: 'break-all'}}>{data.link}</p>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex ms-3'>
                                                                <BsTrash className='text-danger fs-5' onClick={() => deleteLink(index)} style={{cursor: 'pointer'}} />
                                                            </div>
                                                        </div>
                                                    </Row>
                                                )}
                                            </>
                                        )} 
                                        <Button variant="secondary" className='col-md-3' onClick={handleShow}><BsPlusSquareDotted className='me-2'/> Add Link</Button> 
                                        <Modal show={show} centered className='bg-dark'>
                                                    <Modal.Header>
                                                        <Modal.Title>Add Resource Link</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Form.Group className="mb-4 row">
                                                            <Form.Label className='col-md-4'> Resource Title :  <strong>*</strong></Form.Label>
                                                            <Form.Control className='col-md-8 me-2' type="text" placeholder="Enter Resource Title Here" onChange={e => setresTitle(e.target.value)} />
                                                        </Form.Group>
                                                        <Form.Group className="mb-4 row">
                                                            <Form.Label className='col-md-4'> Resource Link :  <strong>*</strong></Form.Label>
                                                            <Form.Control className='col-md-8 me-2' type="text" placeholder="Enter Resource Link Here" onChange={e => setLink(e.target.value)} />
                                                        </Form.Group>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="secondary" onClick={handleLinkClose}>
                                                            Cancel
                                                        </Button>
                                                        <Button variant="warning" onClick={addLinks}>
                                                            Add
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                    </>
                                )}
                            </Col>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    {props.status === "edit" ? (
                        <Button variant="primary" onClick={updateResources}> Update Resource </Button>
                    ) : props.status === "duplicate" ? (
                        <Button variant="primary" onClick={duplicateResource}> Duplicate Resource </Button>
                    ) : (
                        <Button variant="primary" onClick={createResources}> Create Resource </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CreateActivity;